module.exports = __webpack_public_path__ + "static/media/icon-close-handle.86d46def.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-close-handle.svg
// module id = 903
// module chunks = 0